import Box from "@mui/material/Box";
import FormLayoutBalanceDue from "./FormLayoutBalanceDue";
import { useSelector } from "react-redux";
import { TaxCalculations } from "../../../model/tax_calculations";
//import { PayBalanceType } from "../../../model/final_balance/pay_balance_types";
import CityBalanceSummary from "./CityBalanceSummary";
import { toDollar } from "../../../utils/dataConverter";
import CustomButton from "../../../components/CustomButton";
import { goBack, push } from "redux-first-history";
import { useDispatch } from "react-redux";
import { paymentConfig } from "../../../config/paymentConfig";

interface BalanceDueProps {
  taxBreakdown: TaxCalculations,
  finalBalance: number,
}

export default function BalanceDue({
  taxBreakdown,
  finalBalance,
}: BalanceDueProps) {
  const dispatch = useDispatch();
  const {
    data: { collection_year },
  } = useSelector((appState: any) => appState.user);
  //const [balanceOption, setBalanceOption] = useState(PaymentType.Balance);

  const description = (balance: number) => {
    if (!paymentConfig.hideEstimatedPaymentOption && balance > 500) {
      return `Based on your income and credits for ${collection_year}, you may want to make quarterly
    estimated payments toward your ${ Number(collection_year) + 1 } balance so you don’t owe so much next year.

    Lime has calculated estimated quarterly payments to be ${toDollar(taxBreakdown.quarterly_estimated_tax)}.
    On the payment screen you will have the option to pay this year's balance with next year's first quarterly estimate for a total of
      ${toDollar( taxBreakdown.final_balance_with_quarterly_estimated_payment)}.`
    } else {
      return `Next, we'll have you sign your return.`
    }
  }
  // const handleChangeRadio = (event: ChangeEvent<HTMLInputElement>) => {
  //   setBalanceOption(Number((event.target as HTMLInputElement).value));
  //   // TODO: dispatch action? probably not, this is mostly just a transitionary context screen
  // };

  // const key = finalBalance < 500 ? "below500" : "above500";

  return (
    <FormLayoutBalanceDue finalBalance={finalBalance} className="">
      <Box className='card'>
        <CityBalanceSummary taxBreakdown={taxBreakdown} />
      </Box>
      <span> { description(finalBalance) } </span>
      {/* <RadioQuestions */}
      {/*   question={optionsConfig(Number(collection_year), taxBreakdown)[key].description} */}
      {/*   radioOptions={optionsConfig(Number(collection_year), taxBreakdown)[key].options} */}
      {/*   handleChangeRadio={handleChangeRadio} */}
      {/*   radioValue={balanceOption} */}
      {/* /> */}
      <div className='btn-container'>
        <CustomButton
          variant="outlined"
          disableElevation={false}
          label={"back"}
          onClick={() => dispatch(push('/balance'))}
          buttonSize='btn-lg'
        />
        <CustomButton
          variant="contained"
          disableElevation={true}
          label={"next"}
          onClick={() => dispatch(push('/balance/sign')) }
          buttonSize="btn-lg"
        />
      </div>
    </FormLayoutBalanceDue>
  );
}
// const optionsConfig = (collection_year: number, taxBreakdown: TaxCalculations): { [key: string]: UserChoiceGroup } => ({
//   below500: {
//     description: "Next step is to sign your tax return and then start payment! This seems redundant.",
//     options: [
//       { id: PayBalanceType.Balance, label: "Yes, please take me to your payment processor.", disabled: true },
//     ],
//   },
//   // TODO: simplify this to just calculate the amount...
//   above500: {
//     description: `Based on your income and credits for ${collection_year}, you may want to make quarterly
//     estimated payments toward your ${
//       Number(collection_year) + 1
//     } balance so you don’t owe so much next year.
//     Lime has calculated estimated quarterly payments to be
//      ${toDollar(
//       taxBreakdown.quarterly_estimated_amount
//     )}. On the payment screen you will have the option to pay this year's balance with next year's first quarterly estimate for a total of
//       ${toDollar(
//         taxBreakdown.final_balance_with_quarterly_estimated_payment
//       )}.`,
//     options: [
//       { id: PayBalanceType.BalanceWithEstimate, label: "Yes" },
//     ],
//   },
// });
